export default function () {
  window.onNuxtReady(() => {
    window.$nuxt.$on('nuxt-detect-update', () => {
      console.log('update app (reload page...)!')
      document.location.reload();
    })
  })
}
